import React from 'react';
import { TableFilterIdentitySource } from '~/components/Filters';
import { UncontrolledTable } from '~/components';
import usePatient from '~/utils/patient/hook';
import { MatchStatus } from '~/utils/const/identity';

const Allergies = () => {
  const [, { sacwisPersonId: sacwisId }] = usePatient();

  return (
    <UncontrolledTable
      name="allergies"
      className="mx-4"
      endpoint={{
        url: 'data/public/list-view-cs-tbl-allergy',
        params: {
          sacwis_id: sacwisId,
          match_status_id: MatchStatus.Approved,
        },
      }}
      defaultSorted={[
        { id: 'allergen' },
        { id: 'alrgyupddateDt', desc: true },
      ]}
      columns={[
        {
          id: 'allergen',
          Header: 'Allergen',
          accessor: 'attributes.allergen',
        },
        {
          id: 'reactiontype',
          Header: 'Reaction Type',
          accessor: 'attributes.reactiontype',
        },
        {
          id: 'reactioncomment',
          Header: 'Comment',
          accessor: 'attributes.reactioncomment',
        },
        {
          id: 'sourceDescription',
          Header: 'Reporting Healthcare Institution',
          accessor: 'attributes.sourceDescription',
          Filter: d => <TableFilterIdentitySource {...d} />,
        },
        {
          id: 'alrgyupddateDt',
          Header: 'Review Date',
          accessor: 'attributes.alrgyupddateDt',
          cellType: 'date',
        },
      ]}
    />
  );
};

export default Allergies;
